import { set } from 'idb-keyval';
import { STORAGE_KEYS } from './browserStorage';

export const storeSearchByImageData = async (base64: string): Promise<string> => {
	const imageDataId = crypto.randomUUID();

	await set(`${STORAGE_KEYS.searchByImageUpload.key}_${imageDataId}`, base64);

	return imageDataId;
};
